import { InventoryAsset } from '../../../types';

export interface InventoryFieldProps {
  disabled: boolean;
  options: InventoryAsset[];
  displayLocationCode: boolean;
}

export const inventoryLabel = (displayLocationCode: boolean) =>
  displayLocationCode ? 'Existing Inventory Location Code' : 'Existing Inventory';
